/*! @azure/msal-node v3.8.1 2025-10-29 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-node";
const version = "3.8.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
